import { CartService, CartServiceModule } from '@b2b/common/services';
import uiRouter from '@uirouter/angularjs';
import angular from 'angular';

function OrderItemMembershipDirective() {
  OrderItemMembershipController.$inject = [
    '$scope',
    '$rootScope',
    '$state',
    '$q',
    '$filter',
    '$timeout',
    '$uibModal',
    'ApiService',
    'CartService',
    'HelpersService',
    'MembershipService',
  ];

  function OrderItemMembershipController(
    $scope,
    $rootScope,
    $state,
    $q,
    $filter,
    $timeout,
    $uibModal,
    ApiService,
    CartService: CartService,
    HelpersService,
    MembershipService
  ) {
    $scope.orderItemMembership = {
      selectedOffering: false,
      defaults: {
        editable: true,
        removable: true,
        removeLabel: 'Remove',
        editLabel: 'Edit',
      },
      pricepoints: [],
      options: {},
      removeModal: {},
      cartServiceCoupons: CartService.coupons,

      init: function () {
        let actionType;
        const currentMembership = $scope.model;

        $scope.$on('$destroy', $scope.$watch('model.level', this.onLevelUpdate));
        $scope.$on('$destroy', $scope.$watch('options', this.onOptionsUpdate));
        $scope.$on(
          '$destroy',
          $scope.$watchCollection('orderItemMembership.cartServiceCoupons.validCouponCodes', this.onCouponCodesUpdate)
        );
        $scope.$on(
          '$destroy',
          $scope.$watchCollection('orderItemMembership.cartServiceCoupons.invalidCouponCodes', this.onCouponCodesUpdate)
        );
        $scope.$on(
          '$destroy',
          $scope.$watchCollection(
            'orderItemMembership.cartServiceCoupons.conflictingCouponCodes',
            this.onCouponCodesUpdate
          )
        );

        if (!$scope.model.level) {
          if ($scope.model.membershipInfo.membershipId) {
            actionType = MembershipService.getActionFromPurchaseType($scope.model.itemType);
            if (actionType) {
              CartService.memberships
                .lifecycle([actionType], $scope.model)
                .then(this.lifeCycleSuccess, this.lifeCycleFail)
                .then(function () {
                  CartService.memberships.getSubscriptionData(currentMembership);
                });
            }
          } else if ($scope.model.membershipInfo.membershipCategoryId) {
            CartService.memberships
              .levelDetail({ id: $scope.model.membershipInfo.membershipCategoryId })
              .then(this.levelDetailSuccess, this.levelDetailFail);
          }
        } else {
          this.update($scope.model.level.offerings, $scope.model.level.id);
        }
      },

      lifeCycleSuccess: function (response) {
        const self = $scope.orderItemMembership;
        let levels;
        let level;
        let offerings;
        let auxGroup;

        const eligibility = response.data.payload;
        const eligibleLevels = eligibility.membershipOptions.eligibleMembershipLevels;

        if (eligibleLevels.length && eligibleLevels[0].targetLevels.length) {
          levels = eligibleLevels[0].targetLevels.filter(function (targetLevel) {
            return targetLevel.id == $scope.model.membershipInfo.membershipCategoryId;
          });
          if (levels.length) {
            level = levels[0];

            if (level.membershipLevelCollection instanceof Array && level.membershipLevelCollection.length > 0) {
              auxGroup = level.membershipLevelCollection[0].name;
            }

            offerings = level.offerings;
            offerings.forEach(function (offering) {
              offering.displayName = [offering.name, HelpersService.getFormattedDuration(offering.duration)].join(', ');

              offering.term =
                offering.membershipStartDate && offering.membershipExpirationDate
                  ? MembershipService.getMembershipTermFromStartEnd(
                      offering.membershipStartDate,
                      offering.membershipExpirationDate
                    )
                  : MembershipService.purchaseTerm;

              offering.auxGroup = auxGroup;
            });
            level.offerings = offerings;
            CartService.memberships.setLevel($scope.model.membershipInfo.membershipCategoryId, level);
            $scope.model.level = CartService.memberships.processLevel(level);

            self.update(offerings, $scope.model.level.id);
          }
        }
      },

      update: function (offerings, levelId) {
        const self = $scope.orderItemMembership;
        let selectedLevelId;

        $scope.model.level.selectedOffering = CartService.memberships.selectOffering(
          $scope.model.level.pricepoints,
          $scope.model
        );

        const termLoaded = function () {
          $scope.model.couponCodes = CartService.coupons.findMembershipCoupon($scope.model.membershipInfo);

          $timeout(function () {
            $scope.$emit('OrderItem::Update');
          }, 10);
        };

        if (levelId !== undefined) {
          selectedLevelId = levelId;
        } else {
          selectedLevelId = $scope.model.level.selectedOffering.id;
        }

        self.fetchTerm($scope.model.itemType, offerings, levelId, termLoaded);
      },

      lifeCycleFail: function (response) {
        //show error message?
      },

      levelDetailSuccess: function (response) {
        const self = $scope.orderItemMembership;
        let auxGroup;

        const complete = function () {
          $timeout(function () {
            $scope.$emit('OrderItem::Update');
          }, 10);
        };

        const level = response.data.payload;
        const offerings = level.offerings;

        if (level.membershipLevelCollection instanceof Array && level.membershipLevelCollection.length > 0) {
          auxGroup = level.membershipLevelCollection[0].name;
        }

        offerings.forEach(function (offering) {
          offering.displayName = [offering.name, HelpersService.getFormattedDuration(offering.duration)].join(', ');
          offering.term = MembershipService.purchaseTerm;
          offering.auxGroup = auxGroup;
        });

        level.offerings = offerings;
        CartService.memberships.setLevel($scope.model.membershipInfo.membershipCategoryId, level);
        $scope.model.level = CartService.memberships.processLevel(level);
        $scope.model.level.selectedOffering = CartService.memberships.selectOffering(
          $scope.model.level.pricepoints,
          $scope.model
        );
        $scope.model.couponCodes = CartService.coupons.findMembershipCoupon($scope.model.membershipInfo);

        // This is needed for a refresh, we need to refetch the term from the API
        if ($scope.model.level.selectedOffering.term === false) {
          self.fetchTerm($scope.model.itemType, offerings, level.id, complete);
        } else {
          complete();
        }
      },

      fetchTerm: function (itemType, offerings, levelId, done) {
        const selectedOffering = offerings.find(function (element) {
          return $scope.model.level.selectedOffering.offeringId === element.id;
        });

        // No need to calculate if this is a renew as we have the dates
        const isMembershipRenewal = itemType === MembershipService.purchaseTypes.renew.name;
        if (isMembershipRenewal && selectedOffering && selectedOffering.membershipExpirationDate != null) {
          done();
          return;
        }

        const props = {
          action: 'MembershipPurchase',
          levelId: levelId,
          offeringId: $scope.model.level.selectedOffering.offeringId,
          pricePointId: selectedOffering.priceLists[0].prices[0].personType.id,
        };

        ApiService.membership.validate.detail(props).then(function (termInfo) {
          const term = MembershipService.getMembershipTermFromStartEnd(
            termInfo.data.payload.startDate,
            termInfo.data.payload.expirationDate
          );
          $scope.model.level.selectedOffering.term = term;
          done();
        });
      },

      levelDetailFail: function (response) {
        //show error message?
      },

      remove: function () {
        const self = $scope.orderItemMembership,
          hasMemberCategoryDiscount = CartService.hasTransactingMembershipCategory(
            $scope.model.membershipInfo.membershipCategoryId
          ),
          itemId = $scope.model.itemId;

        self.removeModal = $uibModal.open({
          size: 'md',
          controller: 'ConfirmModalController',
          templateUrl: 'common/views/modals/confirm/confirm.tpl.html',
          resolve: {
            modalTitle: function () {
              return 'Are you sure?';
            },
            okText: function () {
              return 'Remove';
            },
            modalMessage: function () {
              return (
                (hasMemberCategoryDiscount
                  ? 'Any member benefits received from <strong>' +
                    $scope.model.membershipInfo.membershipCategoryName +
                    '</strong> will be removed.<br><br>'
                  : '') +
                'Do you want to remove <strong>' +
                $scope.model.membershipInfo.membershipCategoryName +
                '</strong> from the cart?'
              );
            },
          },
        });

        self.removeModal.result.then(
          function () {
            CartService.removeItem(itemId).then(
              function () {
                //if we go from member discounted to no member discounted, we should remove all ticket quantities that were discounted.
                //See cartItemEvent directive (removeDiscountedTickets).
                CartService.clearMembershipDiscountedEvents().then(function () {
                  $scope.$emit('OrderItem::Remove');
                  $rootScope.$emit('OrderItem::Remove');
                  $rootScope.$broadcast('Cart::CouponRefresh');
                });
              },
              function (response) {
                $scope.$emit('OrderItem::Remove::Error', response.data.error);
                $rootScope.$emit('OrderItem::Remove::Error', response.data.error);
                $rootScope.$broadcast('Cart::CouponRefresh');
              }
            );
          },
          function () {
            // Do nothing
          }
        );
      },

      edit: function () {
        $state.go(
          'application.membership.retail',
          $scope.model.membershipInfo.membershipId ? { membershipId: $scope.model.membershipInfo.membershipId } : {}
        );
      },

      getThumbnail: function () {
        let result = '';
        const level = $scope.model.level;

        if (
          level &&
          level.images instanceof Array &&
          level.images.length &&
          level.images[0] &&
          level.images[0].thumbnail
        ) {
          result = level.images[0].thumbnail;
        } else {
          result = '/assets/img/global/no-image-landscape.png';
        }

        return result;
      },

      hasOfferings: function () {
        return (
          $scope.model && $scope.model.level && $scope.model.level.offerings && $scope.model.level.offerings.length
        );
      },

      hasPricepoints: function () {
        return this.pricepoints instanceof Array && this.pricepoints.length;
      },

      isPricepointCount: function (i) {
        return this.hasPricepoints() && this.pricepoints.length === i;
      },

      getLifeCycleLabel: function () {
        return MembershipService.getLifeCycleLabel($scope.model.itemType);
      },

      onLevelUpdate: function (n, o) {
        const self = $scope.orderItemMembership;
        //do nothing for now.
      },

      onOptionsUpdate: function (n, o) {
        const self = $scope.orderItemMembership;
        if (n) {
          self.options = angular.extend(self.defaults, n);
        }
      },

      onCouponCodesUpdate: function (n, o) {
        if (n && n.length) {
          $scope.model.couponCodes = CartService.coupons.findMembershipCoupon($scope.model.membershipInfo);
        }
      },
    };

    $scope.orderItemMembership.init();
  }

  return {
    restrict: 'A',
    replace: true,
    templateUrl: 'common/directives/order/item/membership/membership.tpl.html',
    scope: {
      model: '=',
      options: '=?',
    },

    link: function ($scope, $element, $attrs) {
      // Modified after controller runs
    },

    controller: OrderItemMembershipController,
  };
}

export const OrderItemMembershipDirectiveModule = angular
  .module('acme.common.directive.order.item.membership', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    CartServiceModule,
    'acme.common.service.helpers',
    'acme.common.service.membership',
  ])
  .directive('orderItemMembership', OrderItemMembershipDirective).name;
